
export default {
  props: {
    skill: {type: Object, required: true},
    selected: {type: Boolean, default: false}
  },
  emits: ['edit', 'delete']
}
